import React, { ReactElement } from "react"

import { styled } from "@mui/styles"

import { SadFolderIcon } from "../assets/SadFolderIcon"

interface IProps {
  message?: string,
  description?: string,
  icon?: ReactElement
}

export const NoContent = ({ message, description, icon }: IProps) => {
  return <Wrapper>
    {icon ?? <SadFolderIcon />}
    <Title>{message}</Title>
    <Text>{description}</Text>
  </Wrapper>
}

const Text = styled("div")({
  fontSize: "14px",
  fontWeight: 300,
  fontStyle: "italic"
})

const Title = styled("div")({
  fontWeight: 600,
  fontSize: "18px"
})

const Wrapper = styled("div")({
  padding: "40px 20px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  alignItems: "center",
  textAlign: "center"
})
